import { render } from "./AddLegalEntity.vue?vue&type=template&id=12380fec"
import script from "./AddLegalEntity.vue?vue&type=script&lang=js"
export * from "./AddLegalEntity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__